// src/admin/legal/legalErrorCopy.js — how «Configurazione» → «TOS & Privacy» words a refusal (v219).
// Returns `{ field, key, params, reload }`: `field` = the form field the error belongs on (null = the modal/page),
// `key` = an `admin` namespace key, `reload` = re-read the list (the row changed or vanished meanwhile).
//
// ⛔ Never err.message (the server's English). Legal codes are checked FIRST: admin/adminErrorCopy.js words every
// non-"gone" 404 as «non disponibile», which would be wrong for LEGAL_VERSION_NOT_FOUND / LEGAL_PDF_NOT_FOUND.
// ⚠️ LEGAL_URL_INVALID does not say WHICH link: it lands under both (`links`). Any 413 — the BE's code or nginx's
// HTML page without one — is "file too large".
// Codes: BE src/api/routes/admin_legal.py; table in
// <BACKEND_FOLDER>/docs/frontend/2026-10-30-legal-document-versions-screen-handoff.md § 4.
import { adminErrorCopy } from '../adminErrorCopy.js';

const FIELD = {
  LEGAL_VERSION_EXISTS: { field: 'version', key: 'legalDocuments.errors.versionExists' },
  EFFECTIVE_FROM_IN_PAST: { field: 'effectiveFrom', key: 'legalDocuments.errors.effectiveFromPast' },
  LEGAL_URL_INVALID: { field: 'links', key: 'legalDocuments.errors.urlInvalid' },
  LEGAL_PDF_INVALID: { field: 'file', key: 'legalDocuments.errors.pdfInvalid' },
  LEGAL_PDF_TOO_LARGE: { field: 'file', key: 'legalDocuments.errors.pdfTooLarge' },
};

const RELOAD = {
  LEGAL_VERSION_FROZEN: 'legalDocuments.errors.frozen',
  LEGAL_VERSION_NOT_FOUND: 'legalDocuments.errors.gone',
  LEGAL_PDF_NOT_FOUND: 'legalDocuments.errors.pdfGone',
};

export function legalErrorCopy(err) {
  const code = typeof err?.code === 'string' ? err.code : '';
  const status = typeof err?.status === 'number' ? err.status : null;
  if (FIELD[code]) return { ...FIELD[code], params: {}, reload: false };
  if (status === 413) return { ...FIELD.LEGAL_PDF_TOO_LARGE, params: {}, reload: false };
  if (RELOAD[code]) return { field: null, key: RELOAD[code], params: {}, reload: true };
  if (code === 'AUTH_SUPERADMIN_REQUIRED') {
    return { field: null, key: 'legalDocuments.errors.notSuperadmin', params: {}, reload: false };
  }
  const { key, params } = adminErrorCopy(err);
  return { field: null, key, params, reload: false };
}
